<template>
  <div class="d-flex flex-column flex-column-fluid">
    <!-- Toolbar -->
    <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
      <div
        id="kt_app_toolbar_container"
        class="app-container container-fluid d-flex flex-stack"
      >
        <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
          <h1
            class="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0"
          >
            منصة أكاديميا Academia
          </h1>
          <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
            <li class="breadcrumb-item text-muted">
              <a href="../../demo1/dist/index.html" class="text-muted text-hover-success"
                >الصفحة الرئيسية</a
              >
            </li>
            <li class="breadcrumb-item">
              <span class="bullet bg-gray-400 w-5px h-2px"></span>
            </li>
            <li class="breadcrumb-item text-muted">الإعدادات</li>
          </ul>
        </div>
        <div class="d-flex align-items-center gap-2 gap-lg-3"></div>
      </div>
    </div>

    <!-- Content -->
    <div id="kt_app_content" class="app-content flex-column-fluid">
      <div id="kt_app_content_container" class="app-container container-fluid">
        <!-- حالة التحميل -->
        <div
          v-if="isLoading"
          style="
            font-weight: 800;
            border-radius: 10px;
            padding: 50px;
            font-size: large;
            text-align: center;
            background: #73737326;
          "
          class="loader text-success"
        >
          جاري التحميل
          <div class="spinner-border text-success" role="status">
            <span class="sr-only"></span>
          </div>
        </div>

        <!-- حالة عدم تسجيل الدخول -->
        <div v-if="!isLoggedIn && !isLoading" class="col-12">
          <div class="card text-center p-5 not-login">
            <span class="icon"><i class="bi bi-person-badge"></i></span>
            <h3 class="mb-4">يرجى تسجيل الدخول للإستمرار</h3>
            <span>
              <a href="login" class="btn btn-success">
                تسجيل الدخول <i class="fa fa-sign-in"></i>
              </a>
            </span>
          </div>
        </div>

        <!-- عرض البيانات -->
        <!-- عرض البيانات -->
        <div v-if="isLoggedIn && !isLoading" class="d-flex flex-column">
          <!-- بيانات الأستاذ (ياخذ الصف كامل) -->
          <div class="w-100 mb-10">
            <div
              class="card mb-5 mb-xl-8 shadow-sm border-0 overflow-hidden"
              style="border-radius: 15px"
            >
              <!-- بانر -->
              <div
                style="
                  height: 120px;
                  background: linear-gradient(90deg, #28a745, #218838);
                "
              ></div>

              <!-- جسم البطاقة -->
              <div
                class="card-body text-center position-relative"
                style="margin-top: -60px"
              >
                <!-- صورة الأستاذ -->
                <div
                  class="symbol symbol-150px symbol-circle mb-4 p-1 bg-white"
                  style="
                    border: 4px solid #28a745;
                    border-radius: 50%;
                    overflow: hidden;
                    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
                  "
                >
                  <img
                    :src="instructor.user_img"
                    alt="image"
                    style="object-fit: cover; width: 150px; height: 150px"
                  />
                </div>

                <!-- الاسم -->
                <h2 class="fw-bold text-gray-800 mb-1">
                  {{ instructor.name }}
                </h2>

                <!-- وصف قصير -->
                <span class="text-muted d-block mb-3">محاضر في منصة أكاديميا</span>
                <p style="font-size: small">{{ instructor.details }}</p>

                <!-- تقييم بالنجوم -->
                <div class="mb-3">
                  <i class="fas fa-star text-warning"></i>
                  <i class="fas fa-star text-warning"></i>
                  <i class="fas fa-star text-warning"></i>
                  <i class="fas fa-star text-warning"></i>
                  <i class="fas fa-star text-warning"></i>
                </div>
              </div>
            </div>
          </div>

          <!-- المحتوى (الدورات والباقات) -->
          <div class="w-100">
            <div class="flex-column">
              <!-- Tabs -->
              <ul
                class="nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semibold mb-8"
              >
                <li class="nav-item">
                  <a
                    class="nav-link text-active-success pb-4 active"
                    data-bs-toggle="tab"
                    href="#kt_user_view_overview_tab"
                  >
                    الدورات
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link text-active-success pb-4"
                    data-bs-toggle="tab"
                    href="#kt_user_view_devices_tab"
                  >
                    الباقات
                  </a>
                </li>
              </ul>

              <!-- Tab content -->
              <div class="tab-content">
                <!-- الدورات -->
                <div
                  class="tab-pane fade show active"
                  id="kt_user_view_overview_tab"
                  role="tabpanel"
                >
                  <div class="row">
                    <div
                      v-for="course in courses.data"
                      :key="course.id"
                      class="col-xl-3 col-lg-4 col-md-6 mb-4"
                    >
                      <div class="card text-center h-100">
                        <div class="card-body">
                          <div class="m-1 blog__card--thumbnail">
                            <img
                              class="rounded"
                              :src="course.preview_image"
                              @error="setDefaultImage"
                              alt="Course Thumbnail"
                            />
                          </div>
                          <h5 class="mt-3">
                            <a
                              class="text-success"
                              :href="`/course-details?id=${course.id}`"
                            >
                              {{ course.title }}
                            </a>
                          </h5>
                          <p class="text-muted">
                            {{ course.instructor_name || "بدون اسم" }}
                          </p>
                          <div class="mt-2">
                            <template
                              v-if="
                                course.price === null && course.discount_price === null
                              "
                            >
                              <h3 class="text-success">مجاني</h3>
                            </template>
                            <template v-else-if="course.discount_price">
                              <h3 class="text-danger">{{ course.discount_price }} د.ل</h3>
                              <span class="text-muted text-decoration-line-through">
                                {{ course.price }} د.ل
                              </span>
                              <span class="text-success">
                                ({{
                                  calculateDiscountPercentage(
                                    course.price,
                                    course.discount_price
                                  )
                                }}% تخفيض)
                              </span>
                            </template>
                            <template v-else>
                              <h3 class="text-success">{{ course.price }} د.ل</h3>
                            </template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Pagination -->
                  <nav v-if="courses.meta" aria-label="Page navigation" class="mt-4">
                    <ul class="pagination justify-content-center">
                      <li class="page-item" :class="{ disabled: !courses.links.prev }">
                        <button
                          class="page-link"
                          @click="changePage(courses.meta.current_page - 1)"
                          :disabled="!courses.links.prev"
                        >
                          السابق
                        </button>
                      </li>
                      <li
                        v-for="page in courses.meta.last_page"
                        :key="page"
                        class="page-item"
                        :class="{ active: page === courses.meta.current_page }"
                      >
                        <button class="page-link" @click="changePage(page)">
                          {{ page }}
                        </button>
                      </li>
                      <li class="page-item" :class="{ disabled: !courses.links.next }">
                        <button
                          class="page-link"
                          @click="changePage(courses.meta.current_page + 1)"
                          :disabled="!courses.links.next"
                        >
                          التالي
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>

                <!-- الباقات -->
                <div
                  class="tab-pane fade"
                  id="kt_user_view_devices_tab"
                  role="tabpanel"
                  dir="rtl"
                >
                  <div class="row" id="bundleContainer">
                    <!-- loader -->
                    <div
                      v-if="isLoadingBundles"
                      class="d-flex justify-content-center align-items-center"
                    >
                      <div class="spinner-border text-success" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    </div>

                    <!-- لا يوجد باقات -->
                    <div
                      v-if="
                        bundles.data && bundles.data.length === 0 && !isLoadingBundles
                      "
                      class="col-12"
                    >
                      <div
                        style="
                          margin-bottom: 30px;
                          width: 100%;
                          border-radius: 20px;
                          padding: 10px;
                          color: #000;
                          background: #ffceaa;
                          margin: 20px;
                          text-align: center;
                        "
                      >
                        <b style="font-size: 23px">لا يوجد باقات في هذا التخصص</b><br />
                        <i
                          style="font-size: 120px"
                          class="mdi mdi-alert-rhombus-outline"
                        ></i>
                      </div>
                    </div>

                    <!-- عرض الباقات -->
                    <div
                      v-for="bundle in bundles.data"
                      :key="bundle.id"
                      class="col-xl-3 col-lg-3 col-md-3"
                    >
                      <div class="card text-center">
                        <div class="card-body">
                          <div class="m-1 blog__card--thumbnail">
                            <img
                              class="rounded"
                              :src="bundle.preview_image"
                              @error="setDefaultImage"
                              alt="Bundle Thumbnail"
                            />
                          </div>
                          <h5 class="mt-3">
                            <a
                              class="text-success"
                              :href="`/bundle-details?id=${bundle.id}`"
                            >
                              {{ bundle.title }}
                            </a>
                          </h5>

                          <div class="mt-2">
                            <template
                              v-if="
                                bundle.price === null && bundle.discount_price === null
                              "
                            >
                              <h3 class="text-success">مجاني</h3>
                            </template>

                            <template v-else-if="bundle.discount_price">
                              <h3 class="text-danger">{{ bundle.discount_price }} د.ل</h3>
                              <span class="text-muted text-decoration-line-through"
                                >{{ bundle.original_price }} د.ل</span
                              >
                              <span class="text-success"
                                >({{ bundle.discount_percentage }}% تخفيض)</span
                              >
                            </template>

                            <template v-else>
                              <h3 class="text-success">{{ bundle.price }} د.ل</h3>
                            </template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Pagination -->
                  <nav v-if="bundles.meta" class="mt-4">
                    <ul class="pagination justify-content-center">
                      <li class="page-item" :class="{ disabled: !bundles.links.prev }">
                        <button
                          class="page-link"
                          @click="changeBundlePage(bundles.meta.current_page - 1)"
                          :disabled="!bundles.links.prev"
                        >
                          السابق
                        </button>
                      </li>
                      <li
                        v-for="page in bundles.meta.last_page"
                        :key="page"
                        class="page-item"
                        :class="{ active: page === bundles.meta.current_page }"
                      >
                        <button class="page-link" @click="changeBundlePage(page)">
                          {{ page }}
                        </button>
                      </li>
                      <li class="page-item" :class="{ disabled: !bundles.links.next }">
                        <button
                          class="page-link"
                          @click="changeBundlePage(bundles.meta.current_page + 1)"
                          :disabled="!bundles.links.next"
                        >
                          التالي
                        </button>
                      </li>
                    </ul>
                  </nav>

                  <div id="paginationBundle"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <addDevice />
</template>

<script>
import addDevice from "./addDevice.vue";
import { apiUrl } from "@/utils/api";
export default {
  name: "Settings",
  components: {
    addDevice,
  },
  data() {
    return {
      instructorId: this.$route.query.id,
      isLoggedIn: false,
      isLoading: true,
      token: localStorage.getItem("access_token"),
      instructor: {},
      totalBundlesPages: 0,

      courses: { data: [] },
      bundles: [],
      bundlesPerPage: 20,
      isLoadingBundles: true,

      isInitialCoursesFetch: true, // Flag to check initial fetch
      isInitialBundlesFetch: true, // Flag to check initial fetch
    };
  },
  mounted() {
    this.fetchInstructorDetails();
    this.fetchInstructorCourses();
    this.fetchInstructorBundles();
  },
  methods: {
    async fetchInstructorDetails() {
      try {
        const response = await fetch(`${apiUrl}/instructors/${this.instructorId}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${this.token}`,
            "Content-Type": "application/json",
            "x-country-code": "+218",
          },
        });
        if (!response.ok) throw new Error("Failed to fetch instructor");
        const data = await response.json();
        this.instructor = data.data;
        this.isLoggedIn = true;
      } catch (error) {
        console.error("Error fetching instructor details:", error);
        this.isLoggedIn = false;
      } finally {
        this.isLoading = false;
      }
    },
    async fetchInstructorCourses(page = 1) {
      try {
        const res = await fetch(
          `${apiUrl}/courses/all?user_id=${this.instructorId}&page=${page}`,
          {
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "application/json",
              "x-country-code": "+218",
            },
          }
        );
        const data = await res.json();
        this.courses = data;
      } catch (err) {
        console.error("Error fetching courses:", err);
      }
    },
    async fetchInstructorBundles(page = 1) {
      this.isLoadingBundles = true;
      try {
        const res = await fetch(
          `${apiUrl}/bundles?user_id=${this.instructorId}&page=${page}`,
          {
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "application/json",
              "x-country-code": "+218",
            },
          }
        );

        const result = await res.json();

        // result يحتوي على ( data + links + meta )
        this.bundles = result;
        this.isLoadingBundles = false;
      } catch (err) {
        console.error("Error fetching bundles:", err);
        this.isLoadingBundles = false;
      }
    },
    changePage(page) {
      if (page > 0 && page <= this.courses.meta.last_page) {
        this.fetchInstructorCourses(page);
      }
    },
    initializeBundlesPagination(totalPages) {
      if (this.$bundlesPagination) {
        this.$bundlesPagination.destroy();
      }

      this.$nextTick(() => {
        $("#paginationBundle").twbsPagination({
          totalPages: totalPages,
          visiblePages: 5,
          first: "الأول",
          prev: "السابق",
          next: "التالي",
          last: "الأخير",
          onPageClick: (event, page) => {
            // Only fetch bundles if this is not the initial fetch
            if (!this.isInitialBundlesFetch) {
              this.fetchBundles(page);
            }
            this.isInitialBundlesFetch = false;
          },
        });
      });
    },
    calculateDiscountPercentage(original, discount) {
      return Math.round(((original - discount) / original) * 100);
    },
    setDefaultImage(event) {
      event.target.src = "/default-course.jpg";
    },
    addToCart(courseId, event, type) {
      console.log(`Adding ${type} ${courseId} to cart`);
    },
  },
};
</script>
